<template>
  <TabbedPortlet>

    <TabbedPortletHead>
      <template slot="buttons">
        <button class="btn btn-danger btn-wide">Upload</button>
      </template>
      <li class="nav-item">
        <a href="#" class="nav-link active">
          <font-awesome-icon :icon="['fas', 'folder-open']" size="lg" />
          Files
        </a>
      </li>
    </TabbedPortletHead>

    <TabbedPortletBody>

      <TabbedPortletBodyTab :show="true">
        <FilesTable />
      </TabbedPortletBodyTab>

    </TabbedPortletBody>

  </TabbedPortlet>

</template>

<script>
import TabbedPortlet from '@/components/_shared/tabbed-portlet/TabbedPortlet.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletBodyTab from '@/components/_shared/tabbed-portlet/TabbedPortletBodyTab.vue'

import FilesTable from '@/components/files/FilesTable.vue'

export default {
  name: 'DraftsWrapper',
  components: {
    TabbedPortlet,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletBodyTab,
    FilesTable
  }
}
</script>

<style lang="scss" scoped>
.nav-link:hover,
.nav-link.active,
a.nav-link:hover,
a.nav-link.active {
  color: #cc0000 !important;
  border-bottom: 1px solid #cc0000 !important;
}
</style>
